

















import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import VatsAPI from '@/Shared/VatsAPI';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import Permit from './Permit';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import PermitVariables from '@/Permit/PermitVariables';
import { Logger } from '@/Shared/Logger';
import { Location } from '@/Stores/UserStore';
import { User } from '@/Stores/UserStore';
import { AxiosResponse } from 'axios';
import { Route } from 'vue-router';

const PermitRoot = mixins(LocationBasedMixin).extend({
    props: {
        location: {
            type: String,
            required: false,
        },
        destinationRoute: {
            type: String,
            required: true
        },
        shouldRedirect: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            permitLocations: [] as Location[],
            selectedLocationId: -1,
            i18nPrefix: 'payment.permitPayment',
        };
    },
    computed: {
        selectedLocation(): Location {
            const index = this.permitLocations.findIndex(l => l.locationId === this.selectedLocationId);
            return index >= 0 ? this.permitLocations[index] : null as any as Location;
        }
    },
    async mounted() {
        this.permitLocations = (await VatsAPI.get(`/Permits/locations`)).data;
        if (!this.location) {
            return;
        }

        const currentLocation = this.permitLocations
            .find(item => item.urlSegment.toUpperCase() === this.location?.toUpperCase());

        this.selectedLocationId = currentLocation ? currentLocation.locationId : -1;
        this.locationSelected();
    },
    methods: {
        locationSelected() {
            if (this.shouldRedirect && this.selectedLocation) {
                this.$router.push({
                    name: this.destinationRoute,
                    params: {
                        ['location']: this.selectedLocation.urlSegment
                    }
                });
            }

            if (this.selectedLocationId === -1) {
                this.$router.push({
                    name: 'home'
                });
            }
        }
    },
    watch: {
        selectedLocation() {
            this.locationSelected();
        }
    }
});

export default PermitRoot;
